import { cn } from '@/lib/utils';
import { Check, Copy as CopyIcon, LucideProps } from 'lucide-react';
import { useState } from 'react';

interface CopyProps extends Omit<LucideProps, 'ref'> {
  text: string;
  btnClassName?: string;
}
const Copy = ({ text, btnClassName, ...rest }: CopyProps) => {
  const [copied, setCopied] = useState(false);

  return (
    <button
      onClick={() => {
        const contentToCopy = text === 'undefined' || !text ? '' : text;
        navigator.clipboard.writeText(contentToCopy);
        setCopied(true);
        setTimeout(() => setCopied(false), 1000);
      }}
      className={cn(
        'text-black/70 dark:text-text-tertiary h-[32px] w-[32px] rounded-full flex items-center justify-center hover:bg-[#E9E9E9] dark:hover:bg-[#2c2c2f] transition duration-200 hover:text-black dark:hover:text-white',
        btnClassName,
      )}
    >
      {copied ? <Check size={18} {...rest} /> : <CopyIcon size={18} {...rest} />}
    </button>
  );
};

export default Copy;
